<button
        *ngIf="(isAllowed$ | async) && !jobId"
        mat-raised-button
        (click)="openAtmDialog()"
        class="standard-position">ATM</button>
<button
        *ngIf="(isAllowed$ | async) && jobId"
        mat-button
        (click)="openAtmDialog()">ATM</button>
